import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
  DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { UserSwitch, Check, CaretUpDown } from "@phosphor-icons/react";

// Compact active-profile switcher. Switching re-evaluates all jobs against the
// chosen locked criteria set, so users can match against each profile.
export default function ProfileSwitcher() {
  const [profiles, setProfiles] = useState([]);
  const load = () => api.get("/profiles").then((r) => setProfiles(r.data.profiles));
  useEffect(() => { load(); }, []);

  const active = profiles.find((p) => p.is_active);

  const activate = async (id) => {
    if (id === active?.id) return;
    await api.post(`/profiles/${id}/activate`);
    toast.success("Active profile switched — re-evaluating jobs");
    setTimeout(() => window.location.reload(), 400);
  };

  if (profiles.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="profile-switcher" className="w-full flex items-center gap-2 rounded-md border border-slate-200 bg-white px-3 py-2 text-left hover:border-slate-300 transition-colors">
          <UserSwitch className="text-slate-500 shrink-0" style={{ width: 16, height: 16 }} />
          <div className="min-w-0 flex-1">
            <p className="text-[10px] uppercase tracking-wide text-slate-400 leading-none">Active criteria</p>
            <p className="text-xs font-semibold text-slate-800 truncate mt-0.5">{active?.name || "My criteria"}</p>
          </div>
          <CaretUpDown className="text-slate-400 shrink-0" style={{ width: 14, height: 14 }} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-60 bg-white">
        <DropdownMenuLabel className="text-xs text-slate-500">Match jobs against</DropdownMenuLabel>
        {profiles.map((p) => (
          <DropdownMenuItem key={p.id} onClick={() => activate(p.id)} data-testid={`switch-profile-${p.id}`} className="cursor-pointer">
            <Check className={`mr-2 h-4 w-4 ${p.is_active ? "opacity-100 text-emerald-600" : "opacity-0"}`} />
            <span className="truncate">{p.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
